/**
 * Verifies if the provided email string matches the standard email format.
 *
 * @param {string} email - The email address to verify.
 * @returns {boolean} True if the email format is valid, otherwise false.
 */
function VerifyEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Adds an event listener to the email input and button
 * that enables the button when the email is valid and the button is clicked.
 *
 * @param {string} emailId - The ID of the email input.
 * @param {string} buttonId - The ID of the button.
 * @param {function} callback - The function to call when the button is clicked.
 * @returns {void}
 * @description Adds an event listener to the email input and button
 * that enables the button when the email is valid and the button is clicked.
 */
async function AddEmailListener(emailId, buttonId, callback) {
  const emailInput = document.getElementById(emailId);
  const button = document.getElementById(buttonId);

  if (
    emailInput.getAttribute(emailId + "-listener-added") ||
    button.getAttribute(buttonId + "-listener-added")
  )
    return;

  emailInput.addEventListener("input", async function () {
    if (
      emailInput.validity.valid &&
      emailInput.value !== "" &&
      VerifyEmail(emailInput.value) === true
    ) {
      button.disabled = false;
    } else {
      button.disabled = true;
    }
  });

  button.addEventListener("click", async function () {
    if (button.disabled) return;
    const res = await callback();
    if (res) {
      button.disabled = true;
      emailInput.value = "";
    }
  });

  emailInput.setAttribute(emailId + "-listener-added", true);
  button.setAttribute(buttonId + "-listener-added", true);
}

/**
 * Fetches the provided URL with the provided body and alerts the user
 * with the provided success, API error, or server error text.
 * @param {object} options - The options object.
 * @param {string} options.url - The URL to fetch.
 * @param {object} options.body - The body to send with the fetch request.
 * @param {string} options.successText - The text to display when the fetch request is successful.
 * @param {string} options.apiErrorText - The text to display when the fetch request returns an API error.
 * @param {string} options.serverErrorText - The text to display when the fetch request returns a server error.
 * @returns {void}
 */
async function trpcFetch({
  url,
  body,
  successText,
  apiErrorText = "There was a problem processing your request. Please try again.",
  serverErrorText = "There was a problem communicating with the server. Please try again.",
}) {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ json: body }),
    });
    const data = await response.json();

    if (data.error) {
      console.error("API error:", data.message);
      // alert(apiErrorText);
    } else if (successText) {
      console.log("Success:", data);
      alert(successText);
    }
  } catch (error) {
    console.error("Fetch error:", error);
    // alert(serverErrorText);
  }
}
